<template>
  <div class="row justify-content-center">
    <div class="col-lg-12 col-md-12">
      <section class="gray-simple">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 col-md-12 col-sm-12">
              <div class="property_block_wrap style-2 p-4">
                <div class="prt-detail-title-desc">
                  <h3 class="mt-3">99 Property Management</h3>
                  <div class="mt-2 block-body">
                    <p>
                      Established in 2020, 99 Property Management proudly serves
                      the Greater Moncton area, offering dedicated and reliable
                      property management solutions. Rooted in a commitment to
                      exceptional customer service, we understand the unique
                      needs of property owners and tenants across Moncton,
                      Dieppe, and Riverview. Our experienced team leverages
                      local market knowledge and efficient processes to
                      streamline property operations, ensuring peace of mind for
                      owners and comfortable living for tenants. We strive to
                      build lasting relationships based on trust and
                      transparency, making property management seamless and
                      stress-free for our valued clientele in New Brunswick.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <div class="property_block_wrap style-2 p-4">
                <div class="image-box">
                  <figure class="image">
                    <img :src="app" class="img-fluid" alt="" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12 col-md-12">
            <div class="property_block_wrap style-2">
              <div class="property_block_wrap_header">
                <router-link
                  data-bs-toggle="collapse"
                  data-parent="#dsrp"
                  data-bs-target="#clTwo"
                  aria-controls="clTwo"
                  to=""
                  aria-expanded="true"
                  ><h4 class="property_block_title">Marketing</h4></router-link
                >
              </div>
              <div id="clTwo" class="panel-collapse collapse show">
                <div class="row list-layout">
                  <div class="col-xl-12 col-lg-6 col-md-12">
                    <div
                      class="property-listing property-1 bg-white p-2 rounded"
                      :class="border ? 'border' : 'border-0'"
                    >
                      <div class="listing-img-wrapper">
                        <img
                          :src="m1"
                          class="img-fluid mx-auto rounded"
                          alt=""
                        />
                      </div>
                      <div class="listing-content">
                        <div class="listing-detail-wrapper-box">
                          <div
                            class="listing-detail-wrapper d-flex align-items-center justify-content-between"
                          >
                            <div class="block-body">
                              <p>
                                In Moncton's dynamic rental scene, strategic
                                marketing is paramount for property management.
                                We initiate campaigns by thoroughly
                                understanding local tenant needs and
                                preferences. Our multi-pronged approach utilizes
                                prominent online platforms and engaging social
                                media to ensure maximum visibility, reaching
                                active renters across the Greater Moncton area.
                                High-quality listings featuring professional
                                visuals and comprehensive details about property
                                highlights and nearby conveniences are key to
                                attracting strong tenant interest.
                              </p>
                              <p>
                                Beyond digital channels, we also employ targeted
                                traditional methods, including well-placed
                                signage and collaborations within the Moncton
                                community to generate valuable referrals. We
                                emphasize showcasing each property's unique
                                charm and the advantages of our management
                                services. By continuously analyzing market
                                trends and adapting our strategies, we aim to
                                achieve optimal occupancy and secure reliable
                                tenants for our clients' New Brunswick
                                investments.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="property_block_wrap style-2">
          <div class="property_block_wrap_header">
            <router-link
              data-bs-toggle="collapse"
              data-parent="#dsrp"
              data-bs-target="#clThree"
              aria-controls="clThree"
              to=""
              aria-expanded="true"
              ><h4 class="property_block_title">
                Tenant Screening
              </h4></router-link
            >
          </div>
          <div id="clThree" class="panel-collapse collapse show">
            <div class="row list-layout">
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div
                  class="property-listing property-1 bg-white p-2 rounded"
                  :class="border ? 'border' : 'border-0'"
                >
                  <div class="listing-content">
                    <div class="listing-detail-wrapper-box">
                      <div
                        class="listing-detail-wrapper d-flex align-items-center justify-content-between"
                      >
                        <div class="block-body">
                          <p>
                            Thorough tenant screening is a cornerstone of
                            responsible property management in Moncton. 1 Our
                            process begins with a comprehensive application,
                            gathering essential information about prospective
                            tenants' rental history, employment, and financial
                            stability. We meticulously verify these details
                            through credit checks, landlord references, and
                            income verification, ensuring compliance with all
                            New Brunswick tenancy regulations. This diligent
                            initial assessment is crucial for mitigating risks
                            and securing reliable tenants for our managed
                            properties.
                          </p>
                          <p>
                            Our commitment to effective tenant screening extends
                            beyond basic checks. We prioritize fair and
                            consistent evaluation of all applicants, adhering
                            strictly to human rights legislation in Moncton and
                            New Brunswick. By employing a standardized and
                            transparent process, we aim to select tenants who
                            demonstrate a history of responsible tenancy,
                            respect for property, and the financial capacity to
                            meet their lease obligations, ultimately fostering
                            positive and stable rental environments for our
                            property owners.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="listing-img-wrapper">
                    <img :src="m6" class="img-fluid mx-auto rounded" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="property_block_wrap style-2">
          <div class="property_block_wrap_header">
            <router-link
              data-bs-toggle="collapse"
              data-parent="#dsrp"
              data-bs-target="#clFour"
              aria-controls="clFour"
              to=""
              aria-expanded="true"
              ><h4 class="property_block_title">
                Rent Collection
              </h4></router-link
            >
          </div>
          <div id="clFour" class="panel-collapse collapse show">
            <div class="row list-layout">
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div
                  class="property-listing property-1 bg-white p-2 rounded"
                  :class="border ? 'border' : 'border-0'"
                >
                  <div class="listing-img-wrapper">
                    <img :src="m5" class="img-fluid mx-auto rounded" alt="" />
                  </div>
                  <div class="listing-content">
                    <div class="listing-detail-wrapper-box">
                      <div
                        class="listing-detail-wrapper d-flex align-items-center justify-content-between"
                      >
                        <div class="block-body">
                          <p>
                            Efficient and reliable rent collection is vital for
                            the financial health of any Moncton property
                            investment. Our process is streamlined and
                            convenient for tenants, offering multiple payment
                            options, including secure online portals and direct
                            debit. We establish clear rent due dates and
                            proactively communicate with tenants regarding
                            payment schedules. Our systematic approach ensures
                            timely rent receipt, minimizing delays and
                            maintaining consistent cash flow for our property
                            owners in the New Brunswick region.
                          </p>
                          <p>
                            In the event of late payments, we follow a clearly
                            defined and legally compliant protocol,
                            communicating promptly and professionally with
                            tenants to address outstanding balances. Our goal is
                            to resolve issues efficiently while adhering to all
                            Moncton and provincial tenancy regulations. By
                            prioritizing clear communication and consistent
                            follow-up, we strive to maintain a high rate of rent
                            collection, safeguarding our clients' income and
                            ensuring the financial stability of their valuable
                            property assets.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="property_block_wrap style-2">
          <div class="property_block_wrap_header">
            <router-link
              data-bs-toggle="collapse"
              data-parent="#dsrp"
              data-bs-target="#clFive"
              aria-controls="clFive"
              to=""
              aria-expanded="true"
              ><h4 class="property_block_title">Maintenance</h4></router-link
            >
          </div>
          <div id="clFive" class="panel-collapse collapse show">
            <div class="row list-layout">
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div
                  class="property-listing property-1 bg-white p-2 rounded"
                  :class="border ? 'border' : 'border-0'"
                >
                  <div class="listing-content">
                    <div class="listing-detail-wrapper-box">
                      <div
                        class="listing-detail-wrapper d-flex align-items-center justify-content-between"
                      >
                        <div class="block-body">
                          <p>
                            Proactive and responsive property maintenance is
                            essential for preserving the value and appeal of
                            Moncton rental properties. Our approach involves
                            regular inspections to identify potential issues
                            early, preventing costly repairs down the line. We
                            also establish clear channels for tenants to report
                            maintenance needs promptly. By addressing
                            maintenance requests efficiently and utilizing
                            reliable local contractors in the Moncton area, we
                            ensure properties are well-maintained and tenant
                            satisfaction remains high.
                          </p>
                          <p>
                            Our commitment extends to both routine upkeep and
                            emergency repairs. We coordinate necessary services
                            quickly and effectively, minimizing disruption for
                            tenants and protecting the long-term condition of
                            the property. We prioritize cost-effective solutions
                            while maintaining high standards of workmanship.
                            This diligent attention to property maintenance not
                            only enhances tenant retention but also safeguards
                            our clients' investments in the New Brunswick real
                            estate market.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="listing-img-wrapper">
                    <img :src="m4" class="img-fluid mx-auto rounded" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="property_block_wrap style-2">
          <div class="property_block_wrap_header">
            <router-link
              data-bs-toggle="collapse"
              data-parent="#dsrp"
              data-bs-target="#clSix"
              aria-controls="clSix"
              to=""
              aria-expanded="true"
              ><h4 class="property_block_title">
                Financial Reporting
              </h4></router-link
            >
          </div>
          <div id="clSix" class="panel-collapse collapse show">
            <div class="row list-layout">
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div
                  class="property-listing property-1 bg-white p-2 rounded"
                  :class="border ? 'border' : 'border-0'"
                >
                  <div class="listing-img-wrapper">
                    <img :src="m3" class="img-fluid mx-auto rounded" alt="" />
                  </div>
                  <div class="listing-content">
                    <div class="listing-detail-wrapper-box">
                      <div
                        class="listing-detail-wrapper d-flex align-items-center justify-content-between"
                      >
                        <div class="block-body">
                          <p>
                            Transparent and comprehensive financial reporting is
                            a cornerstone of our property management service in
                            Moncton. We provide owners with clear and concise
                            monthly statements detailing all income and expenses
                            related to their property. These reports offer a
                            complete overview of financial performance,
                            including rent collected, maintenance costs, and any
                            other relevant expenditures, empowering owners to
                            track their investment's profitability with ease in
                            the New Brunswick context.
                          </p>
                          <p>
                            Our financial reporting goes beyond simple
                            summaries. We offer detailed breakdowns of all
                            transactions, ensuring complete transparency and
                            accountability. Owners have access to this
                            information through user-friendly platforms,
                            allowing them to monitor their property's financial
                            health in real-time. We are committed to providing
                            accurate and timely financial insights, enabling our
                            clients to make informed decisions about their
                            Moncton real estate assets and achieve their
                            investment goals.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="property_block_wrap style-2">
          <div class="property_block_wrap_header">
            <router-link
              data-bs-toggle="collapse"
              data-parent="#dsrp"
              data-bs-target="#clSeven"
              aria-controls="clSeven"
              to=""
              aria-expanded="true"
              ><h4 class="property_block_title">
                Evection Protection
              </h4></router-link
            >
          </div>
          <div id="clSeven" class="panel-collapse collapse show">
            <div class="row list-layout">
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div
                  class="property-listing property-1 bg-white p-2 rounded"
                  :class="border ? 'border' : 'border-0'"
                >
                  <div class="listing-content">
                    <div class="listing-detail-wrapper-box">
                      <div
                        class="listing-detail-wrapper d-flex align-items-center justify-content-between"
                      >
                        <div class="block-body">
                          <p>
                            Eviction protection is a key responsibility in
                            Moncton property management. We prioritize rigorous
                            tenant screening to reduce eviction risks. We also
                            emphasize open communication and explore solutions
                            for tenants facing financial challenges, adhering to
                            New Brunswick tenancy laws to avoid eviction
                            whenever possible and foster stable rental
                            situations.
                          </p>
                          <p>
                            When eviction becomes necessary due to lease
                            breaches or non-payment, we expertly manage the
                            legal process, ensuring full compliance with all
                            provincial regulations in Moncton. We handle
                            documentation and communication professionally,
                            protecting our clients' rights while aiming for a
                            fair and legally sound resolution, minimizing
                            financial and legal complications.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="listing-img-wrapper">
                    <img :src="m2" class="img-fluid mx-auto rounded" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <section id="99Pricing">
    <div class="col-lg-12 col-md-12" >
      <div class="sec-heading center mb-4 mt-5">
        <h2>Our Packages!!!</h2>
        <p>
          Please check out our packages and choose the one that best fits your
          needs.
        </p>

        <div
          class="row align-items-start justify-content-center g-lg-4 g-md-3 g-4"
        >
          <div
            v-for="(item, index) in NineNinePlandata"
            :key="index"
            class="col-xl-4 col-lg-4 col-md-4"
          >
            <div class="pricing-wrap py-3 px-3">
              <div class="pricing-header" :class="item.bg">
                <h4 class="pr-value text-light">
                  <!-- <sup class="text-light opacity-75">$</sup>{{ item.value }} -->
                  {{ item.value }}
                </h4>
                <h4 class="pr-title" :class="item.titleText">
                  {{ item.title }}
                </h4>
              </div>
              <div class="pricing-body px-2">
                <ul class="p-0">
                  <li v-for="(el, index) in item.feature" :key="index">
                    <span class="text-success me-2"
                      ><i class="fa-solid fa-circle-check"></i></span
                    >{{ el }}
                  </li>
                </ul>
              </div>
              <div class="pricing-bottom mt-5 mb-3 px-2">
                <router-link to="/contact" :class="item.btn"
                  >ContactUs</router-link
                >
                <div class="row mt-2 d-block g-0">
                  <!-- <div class="col">
                    <span class="text-danger">Set-Up Fee: </span>
                    <span class="">{{ item.setup }} (One Time Fee)</span>
                  </div>
                  <div class="col">
                    <span class="text-danger">Monthly Fee: </span>
                    <span class="">{{ item.fees }}</span>
                  </div> -->
                  <div class="col mt-2">
                    <span><strong class="text-danger">*</strong> Please reach out for promotion details </span>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, defineProps } from "vue"; // 1. Import defineProps
// import { servicesOffered } from "@/data/data";
// import { pricingData } from "@/data/data";
import { NineNinePlandata } from "@/data/data";

// import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import PricingOne from "@/components/pricing-one.vue";
import app from "@/assets/img/99PM_WEBSITE.svg";
import m1 from "@/assets/img/99pm/marketing.jpg";
import m2 from "@/assets/img/99pm/Contract.jpg";
import m3 from "@/assets/img/99pm/Financialreporting.jpg";
import m4 from "@/assets/img/99pm/Maintenance.jpeg";
import m5 from "@/assets/img/99pm/Rentalcollection.jpg";
import m6 from "@/assets/img/99pm/Tenantscreening.jpg";

defineProps({
  border: String
});

const initialized = ref(false);

onMounted(() => {
  if (!initialized.value) {
    initialized.value = true;
  }
});
</script>
